module.exports = __webpack_public_path__ + "static/media/bnb.d0f12dc1.svg";